import { CMArtistMomentum, CMSelect } from "./artist-momentum.styles";
import { useEffect, useState } from 'react';
import GraphMomentum from "../../../Pages/Public/graph-momentum/GraphMomentum";

const ArtistMomentum = ({auction,...props}) => {
    const [career, setCareer] = useState({stage: '', growth: '', network_strength: ''});
    const [stageData, setStageData] = useState([]);
    const [growthData, setGrowthData] = useState([]);
    const [networkStrengthData, setNetworkStrengthData] = useState([]);
    const [selectedTrack, setSelectedTrack] = useState(0);
    const [trackOptions, setTrackOptions] = useState([]);


    useEffect(() => {
        if (auction && auction.tracks) {
          const trackIds = new Set();
          const options = auction.tracks.map((track, index) => {
            const momentumData = !!track.artist_momentum; 
            if (!trackIds.has(track.id) && momentumData) { 
              trackIds.add(track.id);
              return {
                value: String(index),
                label: track.title,
                momentum: momentumData,
              };
            }
            return null;
          }).filter(Boolean); 
          setTrackOptions(options);
        }
      }, [auction]);
/*
    useEffect(() => {
        const career = ARTIST_CAREER;
        setCareer({stage: career.career_stage, growth: career.recent_momentum, network_strength: career.network_strength});
        var stageData = [];
        var stageReverse = stageOptions.slice().reverse();
        for (var i = 0; i < stageReverse.length; i++) {
            stageData.push({ name: stageReverse[i], value: 3, color: COLORS[i]})
            if(stageReverse[i] === career.career_stage) break;
        }
        for (var i = stageData.length; i < stageReverse.length; i++) {
            stageData.push({ name: stageReverse[i], value: 3, color: "#d0d0d0"})
        }
        setStageData(stageData);
        var growthData = [];
        var growthReverse = growthOptions.slice().reverse();
        for (var i = 0; i < growthReverse.length; i++) {
            growthData.push({ name: growthReverse[i], value: 3, color: COLORS[i]})
            if(growthReverse[i] === career.recent_momentum) break;
        }
        for (var i = growthData.length; i < growthReverse.length; i++) {
            growthData.push({ name: growthReverse[i], value: 3, color: "#d0d0d0"})
        }
        setGrowthData(growthData);
        var networkStrengthData = [];
        var networkStrengthReverse = networkStrengthOptions.slice().reverse();
        for (var i = 0; i < networkStrengthReverse.length; i++) {
            networkStrengthData.push({ name: networkStrengthReverse[i], value: 3, color: COLORS[i] })
            if(networkStrengthReverse[i] === career.network_strength) break;
        }
        for (var i = networkStrengthData.length; i < networkStrengthReverse.length; i++) {
            networkStrengthData.push({ name: networkStrengthReverse[i], value: 3, color: "#d0d0d0"})
        }
        setNetworkStrengthData(networkStrengthData);
    }, [])*/
    const handleSelectChange = (e) => {
        setSelectedTrack(e.target.value);  
    };
    if (trackOptions.length === 0) return null;
    return (
        <CMArtistMomentum {...props}>
            <h3>Artist Momentum</h3>
            {trackOptions.length > 0  ? (
                <>
                    {trackOptions.length !== 1 && (
                        <CMSelect value={selectedTrack} onChange={handleSelectChange}>
                            <option value="" disabled>Select a track</option>
                            {trackOptions.map((option, index) => (
                                    <option key={index} value={option.value}>
                                        {option.label}
                                    </option>
                            ))}
                        </CMSelect>
                    )}
            <GraphMomentum auction={auction} selectedTrack={selectedTrack} />
            </>
            ):(
                <p style={{marginTop:"30px"}}>No Artist Momentum</p>
            )}
            {/*<Image src={URLImages.urlArtistMomentum} className="CMImageSize" />*/}
        </CMArtistMomentum>
    );
}
/*
const stageOptions = ['Legendary', 'Superstar', 'Mainstream', 'Mid-Level', 'Developing'];

const growthOptions = ['Explosive Growth', 'Growth', 'Steady', 'Gradual Decline', 'Decline'];

const networkStrengthOptions = ['Influential', 'Prominent', 'Established', 'Emerging', 'Active'];

const COLORS = ['#FF8A4C', '#5850EC', '#40CDAE', '#46B29A', '#C321F3'];

const ArtistStageChart = ({title, tooltip, options, data, active, ...props}) => {
    return (
        <CMArtistStageChart {...props}>
            <div className="chart-content" >
                <div className="chart-size">
                    <div className="chart-title">
                        <h6>
                            {title}
                            <HelpTooltip title={tooltip} />
                        </h6>
                    </div>
                    <ResponsiveContainer>
                        <PieChart>
                            <Pie
                                dataKey='value'
                                data={data}
                                startAngle={180}
                                endAngle={0}
                                innerRadius={76}
                                outerRadius={85}
                                fill="color"
                                paddingAngle={5}
                                cornerRadius={8}
                            >
                                {data && data.length ? data.map((entry, index) => {
                                    return <Cell key={`cell-${index}`} fill={entry.color} />
                                }): ''}
                            </Pie>
                            <foreignObject x="0" y="0" width="100%" height="100%">
                                <div className="chart-label">
                                    <span>{active}</span>
                                </div>
                            </foreignObject>
                        </PieChart>
                    </ResponsiveContainer>
                </div>
                <div className="chart-options">
                    {options.map((option, index) => {
                        return (
                            <div key={`option-${index}`} className={option === active ? 'active': ''}>
                                {option === active ? <img src="https://storage.googleapis.com/cm-app-assets/icons/arrow-right.svg"/> : ''}
                                {option}
                            </div>
                        )
                    })}
                </div>
            </div>
        </CMArtistStageChart>
    )
}*/
export default ArtistMomentum;